import { Maybe } from 'app/common/types';
import { FlowNode, TestStatus } from '../flowState';
import isNodeTemplate from './isNodeTemplate';
import requiresLiveData from './requiresLiveData';

const isTemplateNodeUsingSampleData = (node?: FlowNode) =>
  Boolean(node && isNodeTemplate(node) && !requiresLiveData(node));

const isValidSampleStatus = (node: FlowNode, status: Maybe<TestStatus>) => {
  return (
    // Assume all sample data in ZTs are valid
    isTemplateNodeUsingSampleData(node) ||
    status === 'data' ||
    // TODO: When all writes are flow-compatible, remove this special nodata case
    (status === 'nodata' && node.type_of === 'write')
  );
};

export default isValidSampleStatus;
